<template>
  <div>
    <div style="float: right">
      <datetime-range id="custom-datetime-range" :allow-clear="false" :default-value="datetimeRange" @ok="
        v => {
          datetimeRange = v
        }
      "></datetime-range>
    </div>
    <div style="clear: both"></div>
    <div class="module-container" style="height: 370px; margin: 16px 1px 0 1px">
      <log-chart-card :get-func="getTrendFunc" :datetime-range="datetimeRange"></log-chart-card>
    </div>

    <div class="module-container" style="min-height: 400px; margin: 16px 1px 0 1px">
      <div class="module-header" style="margin-bottom: 14px">
        详细日志表
      </div>
      <log-table :datetime-range="datetimeRange" :columns="columns" :get-func="getTableFunc"></log-table>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { getServiceStatisticLogList, getServiceStatisticTrend } from '@/api/log'
import DatetimeRange from '@/components/DatetimeRange'
import LogChartCard from './modules/LogChartCard.vue'
import LogTable from './modules/LogTable.vue'

export default {
  name: 'ServiceStisticsLog',
  components: {
    DatetimeRange,
    LogChartCard,
    LogTable
  },
  data() {
    return {
      datetimeRange: [moment().subtract(1, 'hour'), moment()],
      getTrendFunc: getServiceStatisticTrend,
      getTableFunc: getServiceStatisticLogList,
      columns: [
        // {
        //   dataIndex: 'timestamp',
        //   title: '采集时间',
        //   width: 200,
        //   scopedSlots: {
        //     customRender: 'timestamp'
        //   }
        // },
        // {
        //   dataIndex: 'hostip',
        //   title: 'IP 地址',
        //   width: 160,
        //   key: 'hostip',
        //   scopedSlots: {
        //     filterDropdown: 'filterDropdown',
        //     filterIcon: 'filterIcon',
        //     customRender: 'hostip'
        //   }
        // },
        {
          dataIndex: 'time_local',
          title: '统计时间',
          width: 160,
          scopedSlots: {
            customRender: 'timeLocal'
          }
        },
        {
          dataIndex: 'service',
          title: '监控识别 ID',
          width: 200,
          key: 'service',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'service'
          }
        },


        {
          dataIndex: 'related_services',
          title: '业务系统',
          width: 200,
          key: 'related_services',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'related_services'
          }
        },

        {
          dataIndex: 'module',
          title: '重要服务名称',
          width: 200,
          key: 'module',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'module'
          }
        },
        {
          dataIndex: 'requests',
          title: '请求数',
          width: 120,
          key: 'requests',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'requests'
          }
        },
        {
          dataIndex: 'requests_failed',
          title: '错误数',
          width: 120,
          key: 'requests_failed',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'requestsFailed'
          }
        },
        {
          dataIndex: 'request_success_rate',
          title: '请求成功率 (%)',
          width: 160,
          key: 'request_success_rate',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'requestSuccessRate'
          }
        },
        {
          dataIndex: '95th_request_time',
          title: 'P95 响应时长 (ms)',
          width: 160,
          key: '95th_request_time',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: '95thRequestTime'
          }
        },
        {
          dataIndex: '2xx',
          title: '2XX 数',
          width: 120,
          key: '2xx',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: '2xx'
          }
        },
        {
          dataIndex: '4xx',
          title: '4XX 数',
          width: 120,
          key: '4xx',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: '4xx'
          }
        },
        {
          dataIndex: '5xx',
          title: '5XX 数',
          width: 120,
          key: '5xx',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: '5xx'
          }
        }
      ]
    }
  }
}
</script>
<style lang="less">
.module-container {
  position: relative;
  background: #fff;
  border-radius: 6px;
  padding: 16px;
  overflow: hidden;
  box-shadow: rgba(0, 0, 0, 0.08) 0px 0px 8px;
}
</style>
